import { render, staticRenderFns } from "./DialogFormAssetStatusEdit.vue?vue&type=template&id=b8c6384e"
import script from "./DialogFormAssetStatusEdit.vue?vue&type=script&lang=js"
export * from "./DialogFormAssetStatusEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports